import React from 'react';
import { Box, Container, Paper, Typography, Grid } from '@mui/material';
import {
  PhoneInTalk as PhoneIcon,
  AccessTime as TimeIcon,
  MoneyOff as FreeIcon,
} from '@mui/icons-material';
import PublicHeader from '../components/PublicHeader';
import RegisterConsultForm from '../components/RegisterConsultForm';
import bgImage from '../assets/images/login-bg.jpg';

const GRADIENT = 'linear-gradient(45deg, #1a237e 30%, #3949ab 90%)';

const HIGHLIGHTS = [
  { icon: <FreeIcon />, title: 'کاملاً رایگان', desc: 'استفاده از سامانه هیچ هزینه‌ای ندارد.' },
  { icon: <PhoneIcon />, title: 'مشاورهٔ تخصصی', desc: 'همکاران ما رایگان راهنمایی‌تان می‌کنند.' },
  { icon: <TimeIcon />, title: 'تماس سریع', desc: 'تا ۶ ساعت آینده با شما تماس می‌گیریم.' },
];

const RegisterPage = () => {
  const scrollToForm = () => {
    const el = document.getElementById('register-form');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f4f6fb' }}>
      {/* روی این صفحه، دکمهٔ «ثبت‌نام و مشاوره» هدر به فرم همین صفحه اسکرول می‌کند */}
      <PublicHeader onOpenConsult={scrollToForm} />

      {/* بخش معرفی - سئو */}
      <Box sx={{
        position: 'relative',
        py: { xs: 6, md: 9 },
        px: 2,
        textAlign: 'center',
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}>
        <Box sx={{ position: 'absolute', inset: 0, bgcolor: 'rgba(13, 22, 66, 0.7)' }} />
        <Box sx={{ position: 'relative', color: 'white', maxWidth: 760, mx: 'auto' }}>
          <Typography variant="h3" component="h1"
            sx={{ fontWeight: 'bold', mb: 2, fontSize: { xs: '1.8rem', md: '2.6rem' } }}>
            ثبت‌نام و مشاورهٔ رایگان سامانهٔ مدیریت پرده‌فروشی
          </Typography>
          <Typography variant="h6" component="p" sx={{ opacity: 0.92, fontWeight: 'normal', lineHeight: 2 }}>
            با گالری پرده، مدیریت مشتریان، ثبت سفارش و اندازه‌گیری، پیگیری مراحل دوخت و نصب،
            و صدور فاکتور پرده‌فروشی خود را ساده و یکپارچه انجام دهید. برای شروع، فرم زیر را تکمیل کنید.
          </Typography>
        </Box>
      </Box>

      {/* ویژگی‌ها */}
      <Container maxWidth="lg" sx={{ mt: { xs: -4, md: -5 }, position: 'relative', zIndex: 2 }}>
        <Grid container spacing={2}>
          {HIGHLIGHTS.map((h) => (
            <Grid item xs={12} sm={4} key={h.title}>
              <Paper elevation={3} sx={{ p: 2.5, borderRadius: 3, textAlign: 'center', height: '100%' }}>
                <Box sx={{
                  width: 48, height: 48, borderRadius: '50%', background: GRADIENT,
                  color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  mx: 'auto', mb: 1.5,
                }}>
                  {h.icon}
                </Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 0.5 }}>{h.title}</Typography>
                <Typography variant="body2" color="text.secondary">{h.desc}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* فرم */}
      <Container maxWidth="sm" id="register-form" sx={{ py: { xs: 5, md: 7 } }}>
        <Paper elevation={2} sx={{ p: { xs: 3, md: 4 }, borderRadius: 3 }}>
          <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', color: '#1a237e', mb: 1 }}>
            فرم ثبت‌نام و مشاوره
          </Typography>
          <RegisterConsultForm />
        </Paper>
      </Container>

      {/* فوتر */}
      <Box sx={{ background: GRADIENT, color: 'white', py: 3, textAlign: 'center' }}>
        <Typography variant="body2">© محمد نشیبی - ۱۴۰۴</Typography>
      </Box>
    </Box>
  );
};

export default RegisterPage;
